import React, { useState } from 'react';

// components
import ModalForm from '../../../components/ModalForm/ModalForm';
import EmptyData from '../../../components/EmptyData/EmptyData';

// icons
import icon from '../../../brand/generated/buttonIcons/addDeal.svg';

const formStyles = {
  record: { display: 'grid', gap: '20px', gridTemplateAreas: `'a a k k' 'b b b b' 'c c v v' 'd d d d' 'f f f f'` },
};

const NewClientsRecord = () => {
  const [showModal, setShowModal] = useState(false);
  const [record, setRecord] = useState([
    { type: 'input', label: 'ÐÐ°ÑÐ°', value: '01.11.2022', disabled: true },
    { type: 'input', label: 'ID', value: '35567809', disabled: true },
    { type: 'select', label: 'ÐÐ»Ð¸ÐµÐ½Ñ', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°', style: { gridArea: 'k' } },
    { type: 'select', label: 'Ð¡ÑÐ°ÑÑÑ Ð·Ð°Ð¿Ð¸ÑÐ¸', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°' },
    { type: 'select', label: 'ÐÑÑÐ¾ÑÐ½Ð¸Ðº', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°' },
    { type: 'date', label: 'ÐÐ°ÑÐ°', placeholder: 'Ð´Ð´-Ð¼Ð¼-Ð³Ð³Ð³Ð³' },
    { type: 'select', label: 'ÐÑÐµÐ¼Ñ', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°' },
    { type: 'select', label: 'Ð£ÑÐ»ÑÐ³Ð°', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°', style: { gridArea: 'c' } },
    { type: 'select', label: 'ÐÐ´ÑÐµÑ Ð´Ð¸Ð»ÐµÑÑÐºÐ¾Ð³Ð¾ ÑÐµÐ½ÑÑÐ°', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°', style: { gridArea: 'v' } },
    { type: 'select', label: 'ÐÑÐ²ÐµÑÑÑÐ²ÐµÐ½Ð½ÑÐ¹ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°', style: { gridArea: 'd' } },
    {
      type: 'input',
      label: 'ÐÐ°Ð¼ÐµÑÐºÐ¸/ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ Ð·Ð°Ð¿Ð¸ÑÐ¸',
      placeholder: 'ÐÑÑÐ°Ð²ÑÑÐµ Ð²Ð°Ñ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹',
      style: { gridArea: 'f' },
    },
  ]);

  return (
    <>
      <EmptyData
        title={'ÐÐ°Ð¿Ð¸ÑÐ¸ (0)'}
        subtitle={'ÐÐ°Ð¿Ð¸ÑÐµÐ¹ Ð¿Ð¾ÐºÐ° Ð½ÐµÑ'}
        action="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð½Ð¾Ð²ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ"
        icon={icon}
        showModal={() => setShowModal(true)}
      />
      {showModal && (
        <div
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            display: 'flex',
          }}
        >
          <div style={{ width: '316px' }} />
          <ModalForm
            title={'ÐÐ¾Ð²Ð°Ñ ÑÐ´ÐµÐ»ÐºÐ° Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð¼'}
            closeModal={() => setShowModal(false)}
            mainForm={record}
            formTitle={'ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ ÑÐ´ÐµÐ»ÐºÐµ'}
            grid={formStyles.record}
            action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ'}
          />
        </div>
      )}
    </>
  );
};

export default NewClientsRecord;
